'use client';

import React from 'react';
import { useTranslations } from 'next-intl';
import { Search, X } from 'lucide-react';
import { Input } from '@/shared/components/ui/input';
import { Button } from '@/shared/components/ui/button';

interface ListFiltersProps {
  searchValue?: string;
  onSearchChange?: (value: string) => void;
  searchPlaceholder?: string;
  searchTestId?: string;
  children?: React.ReactNode;
}

export function ListFilters({
  searchValue,
  onSearchChange,
  searchPlaceholder,
  searchTestId,
  children,
}: ListFiltersProps) {
  const t = useTranslations('common');
  const showSearch = onSearchChange !== undefined;

  return (
    <div className="flex flex-col gap-2 sm:flex-row sm:items-center" data-testid="list-filters">
      {showSearch && (
        <div className="relative flex-1 max-w-sm">
          <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
          <Input
            data-testid={searchTestId}
            placeholder={searchPlaceholder}
            value={searchValue ?? ''}
            onChange={(e) => onSearchChange(e.target.value)}
            className="pl-9 pr-8"
          />
          {searchValue && (
            <Button
              variant="ghost"
              size="icon"
              className="absolute right-1 top-1/2 -translate-y-1/2 h-6 w-6"
              onClick={() => onSearchChange('')}
              aria-label={t('clearSearch')}
            >
              <X className="h-3.5 w-3.5" />
            </Button>
          )}
        </div>
      )}
      {children && (
        <div className="flex items-center gap-2">
          {children}
        </div>
      )}
    </div>
  );
}
